import { render, staticRenderFns } from "./CRRichText.vue?vue&type=template&id=63f5c562&scoped=true"
import script from "./CRRichText.vue?vue&type=script&lang=js"
export * from "./CRRichText.vue?vue&type=script&lang=js"
import style0 from "./CRRichText.vue?vue&type=style&index=0&id=63f5c562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5c562",
  null
  
)

export default component.exports